"use client"

import { NftSearchResult } from "@/app/nft/search/result/view/nft-search-result"
import type { ViewType } from "@/app/nft/search/result/view/view-selector/types"
import { useViewSelector } from "@/app/nft/search/result/view/view-selector/use-view-selector"
import { ViewSelector } from "@/app/nft/search/result/view/view-selector/view-selector"
import { NftSortPicker } from "@/app/nft/search/sort"
import { ProfileBlockchainFilters } from "@/app/profiles/profile-blockchain-filters"
import type { AvailableNftSort } from "@anaconda/core/nft/search/types"
import { NftSort } from "@anaconda/core/nft/search/types"
import { Trans } from "@lingui/react/macro"

interface Props {
  initialViewType: ViewType
}

export function ProfileItemsView({ initialViewType }: Props) {
  const SORT_OPTIONS: { type: AvailableNftSort; label: React.ReactNode }[] = [
    {
      type: NftSort.LOW_PRICE_FIRST,
      label: <Trans>Price: Low to High</Trans>,
    },
    {
      type: NftSort.HIGH_PRICE_FIRST,
      label: <Trans>Price: High to Low</Trans>,
    },
    { type: NftSort.RECENTLY_RECEIVED, label: <Trans>Recent</Trans> },
  ]

  const { viewType, setViewType } = useViewSelector(initialViewType)

  return (
    <div
      className="flex flex-1 flex-col gap-4"
      data-testid="profile-items-view"
    >
      <div className="flex flex-wrap items-center gap-4 md:flex-nowrap md:justify-end">
        <ProfileBlockchainFilters />

        <NftSortPicker
          sortOptions={SORT_OPTIONS}
          initialSort={NftSort.RECENTLY_RECEIVED}
        />
        <ViewSelector onChange={setViewType} value={viewType} />
      </div>
      <NftSearchResult viewType={viewType} />
    </div>
  )
}
